<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.cadastro.funcionalidade"
        ref="RkmDataTable"
    >
        <template v-slot:cell(actions)="{item}">
            <rkm-button
                v-if="authorize('cadastro-funcionalidade-update')"
                :to="{name: 'cadastro-funcionalidade-edit', params: {id: item.funcionalidade_id}}"
                color="primary"
                small
                title="Parametrizar"
                v-rkm-tooltip.hover
            >
                <rkm-icon icon="cog" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import {authorization} from '@/mixins'

export default {
    computed: {
        fields() {
            return [
                {key: 'sistema_nome', label: 'Sistema', name: 'cadastro_sistema.nome', searchable: true, sortable: true},
                {key: 'modulo_nome', label: 'Módulo', name: 'cadastro_modulo.nome', searchable: true, sortable: true},
                {key: 'funcionalidade_nome', label: 'Nome', name: 'cadastro_funcionalidade.nome', searchable: true, sortable: true},
                {key: 'funcionalidade_identificador', label: 'Identificador', name: 'cadastro_funcionalidade.identificador', searchable: true, sortable: true},
                {class: 'col-min text-center', key: 'actions', label: 'Ações'},
            ]
        },
    },
    inject: ['repositories'],
    mixins: [authorization],
}
</script>